import request from './base/http';

export default {
  // 保存接口
  getDetailAcCard(data) {
    return request({
      method: 'get',
      url: '/dtk/dtk_main/GetDetailAcCard',
      params: data,
    });
  },
  addCard(data) {
    return request({
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      url: '/dtk/dtk_main/AddAcCard',
      data,
    });
  },
  uploadImage(data) {
    return request({
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      url: '/dtk/image/uploadBase64',
      data,
    });
  },
};
